import { AdUnitService } from '../../../../../../../services/adunit.service';
import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Helpers } from '../../../../../../../helpers';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '../../../../base.component';

@Component({
    selector: 'app-list-adUnit',
    templateUrl: './list-adunit.component.html',
    encapsulation: ViewEncapsulation.None
})
export class ListAdUnitComponent extends BaseComponent implements OnInit {
    datatable: any;
    closeResult: string;
    adUnits: any;
    path: string;
    selectedAdUnitId: string;

    private _pageId: string;
    get pageId(): string {
        return this._pageId;
    }
    @Input()
    set pageId(pageId: string) {
        this._pageId = pageId;
        if (!this._pageId) {
            this.adUnits = [];
            return;
        }
        this.getAdUnits(pageId);
    }

    @Input() siteId: string;
    @Input() routePath: string;
    @Input() publisherName: string;
    @Input() siteName: string;
    @Input() pageName: string;

    constructor(
        private adunitService: AdUnitService,
        private router: Router,
        private modalService: NgbModal,
        private route: ActivatedRoute
    ) {
        super();
        route.snapshot.queryParams.siteId;
        this.path = Helpers.getPath();
    }

    open(content) {
        this.modalService.open(content).result.then(
            result => {
                this.closeResult = `Closed with: ${result}`;
            },
            reason => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return 'by pressing ESC';
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return 'by clicking on a backdrop';
        } else {
            return `with: ${reason}`;
        }
    }

    openCodeModal() {
        (<any>$('#codeModal')).modal();
    }

    closeModal() {
        (<any>$('.modal')).modal('hide');
    }

    deleteAdUnit(adunitid: string) {
        this.swalService.confirmDelete().then(res => {
            if (res.value) {
                Helpers.setLoading(true);
                this.adunitService.delete(adunitid).subscribe(() => {
                    Helpers.setLoading(false);
                    this.getAdUnits(this._pageId);
                    this.swalService.successDelete();
                });
            }
        });
    }

    ngOnInit() { }

    getAdUnits(pageId) {
        Helpers.setLoading(true);
        this.adunitService.list({ filterId: pageId }).subscribe(res => {
            this.adUnits = res.data;
            Helpers.setLoading(false);
        });
    }

    onSelect(id) {
        this.selectedAdUnitId = id;
    }

    onClickCreateAdUnit() {
        if (!this.pageId || !this.siteId) return;
        this.router.navigate(['/' + this.path + '/inventory/adunit/create'], {
            queryParams: {
                siteId: this.siteId,
                pageId: this.pageId,
                siteName: this.siteName,
                pageName: this.pageName,
                publisherName: this.publisherName,
                returnUrl: this.routePath
            }
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/shared/inventory/adunit/list-adunit/list-adunit.component.ts